import {
  Flex,
  MultiSelect,
  MultiSelectComponentProps,
  OpenerLabel,
  Paragraph,
  RenderOptionFunctionProps,
  SelectMultipleOptionComponent,
  Status,
} from "@eworkit/iris";
import React from "react";
import { useTranslation } from "react-i18next";

import { LazyUserAvatar } from "@/components/avatars";
import { IConsultantProfile } from "@/data/consultant-profiles";
import { formatFullName } from "@/data/persons";
import { UserBase } from "@/data/users";

export interface ConsultantMultiSelectProps extends MultiSelectComponentProps<IConsultantProfile> {}

export const ConsultantMultiSelect: React.FC<ConsultantMultiSelectProps> = ({
  ...props
}: ConsultantMultiSelectProps) => {
  const { t } = useTranslation("session");

  function renderOption<T extends UserBase>(data: RenderOptionFunctionProps<T>) {
    return (
      <SelectMultipleOptionComponent checked={data.checked}>
        <Flex gap="xs" alignItems="center" sx={{ py: "xs" }}>
          <LazyUserAvatar size="xs" user={data.value} />
          <Paragraph size="p-md">{formatFullName(data.value)}</Paragraph>
        </Flex>
      </SelectMultipleOptionComponent>
    );
  }

  function renderValue<T extends UserBase>(value?: T[] | null) {
    return Array.isArray(value) ? (
      <Flex gap="xs" alignItems="center">
        <Status size="md">{value.length}</Status>
        <OpenerLabel>{value.map(formatFullName).join(", ")}</OpenerLabel>
      </Flex>
    ) : null;
  }

  const labelSelector = (v: UserBase) => formatFullName(v);
  const identifierSelector = (v: UserBase) => v.id ?? -1;

  return (
    <MultiSelect
      renderOption={renderOption}
      renderValue={renderValue}
      labelSelector={labelSelector}
      identifierSelector={identifierSelector}
      searchable={true}
      ariaSearchLabel={t("JOB_APPLICATIONS.LIST.FILTERS.SEARCH")}
      {...props}
    />
  );
};
